import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import { createCorporatePlan, AllCorporatePlan, deleteCorporatePlane, EditCorporatePlane, UpdateCorporatePlane } from "../CorporatePlan/service";
/**
 * Create Plan
 */
function* createPlan({ postData }) {
  try {
    const { data } = yield call(createCorporatePlan, postData);
    yield put({
      type: Actions.CREATE_CORPORATE,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.CREATE_CORPORATE_ERROR,
      error: error,
    });
  }
}

/**
 * load all Plan
 */
function* listAllCorporate() {
  try {
    const { data } = yield call(AllCorporatePlan);
    yield put({
      type: Actions.CREATE_CORPORATE_ALL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.CREATE_CORPORATE_ALL_ERROR,
      error: error,
    });
  }
}

/**
 * delete corporate
 */
function* deleteCorporateData(id) {
  try {
    const { data } = yield call(deleteCorporatePlane, id);
    yield put({
      type: Actions.DELETE_CORPORATE_SUCCESS,
      payload: "deleted",
    });
  } catch (error) {
    yield put({
      type: Actions.DELETE_CORPORATE_ERROR,
      error: error,
    });
  }
}

/**
 * Edit corporate
 */
function* editPlans({ id }) {
  try {
    const { data } = yield call(EditCorporatePlane, id);
    yield put({
      type: Actions.EDIT_CORPORATE_PLAN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.EDIT_CORPORATE_PLAN_ERROR,
      error: error,
    });
  }
}

/**
 * Update corporate
 */
function* UpdatePlan({ postData }) {
  try {
    const { data } = yield call(UpdateCorporatePlane, postData);
    yield put({
      type: Actions.CREATE_CORPORATE,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.CREATE_CORPORATE_ERROR,
      error: error,
    });
  }
}

export default function* CorporatePlanSaga() {
  yield takeEvery(Actions.CREATE_CORPORATE, createPlan);
  yield takeEvery(Actions.CREATE_CORPORATE_ALL, listAllCorporate);
  yield takeEvery(Actions.DELETE_CORPORATE, deleteCorporateData);
  yield takeEvery(Actions.EDIT_CORPORATE_PLAN, editPlans);
  yield takeEvery(Actions.UPDATE_CORPORATE_PLAN, UpdatePlan);
}